import React from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { string, number, bool, func, node, oneOfType } from 'prop-types';
import CustomControl from '../CustomControl/CustomControl';
import Hint from '../Hint/Hint';
import FeatureListItemControl from './FeaturesListItemControl';
import { ThemedFMessage, ThemedHTMLMessage } from '../../hoc/IntlComponents';
import { STATIC_PATH } from '../../config';

const propTypes = {
  id: oneOfType([string, number]).isRequired,
  selected: bool.isRequired,
  paramName: string.isRequired,
  onChange: func.isRequired,
  label: node,
  defaultLabel: oneOfType([string, number]),
  title: string,
  desc: string,
};
const defaultProps = {
  tag: 'li',
  selected: false,
  onChange() { },
};

const FeatureListItem = ({
  id,
  label,
  defaultLabel,
  selected,
  type,
  paramName: name,
  title,
  defaultTitle,
  desc,
  defaultDesc,
  onChange,
  tag: Tag,
  inputType,
  value,
  options,
  placeholder,
  preview,
  ...rest
}) => {
  const TranslationFTag = id === 2 ? ThemedFMessage : FormattedMessage;
  const TranslationHTMLTag = id === 2 ? ThemedHTMLMessage : FormattedHTMLMessage;

  // нужно чтобы поповер был посередине
  const getBoundaryEl = () => document.querySelector('#landings-card') || document.querySelector('body');
  const getContainer = () => document.querySelector('#landings-card') || 'body';

  return (
    <Tag>
      <FeatureListItemControl
        id={`feature_${id}`}
        className="custom-control-xs"
        checked={selected}
        value={value}
        name={name}
        onChange={onChange}
        inputType={inputType}
        options={options}
        placeholder={placeholder}
        {...rest}
      >
        {label && <span className={`${selected ? '' : 'disabled'}`}><TranslationFTag id={label} defaultMessage={defaultLabel} /></span>}

      </FeatureListItemControl>

      {desc && (
        <Hint
          title={<TranslationFTag id={title} />}
          id={`feature_hint_${id}`}
          placement="bottom"
          popoverClassName="feature-hint-popover"
          boundariesElement={getBoundaryEl()}
          container={getContainer()}
        >
          <TranslationHTMLTag tagName="div" id={desc} defaultMessage={defaultDesc} />
          {preview ? (
            <img
              src={`${STATIC_PATH}/img/flow-feature-previews/${id}.png`}
              className="feature-hint-preview-img"
            />
          ) : null}
        </Hint>
      )}
    </Tag>
  )
};

FeatureListItem.propTypes = propTypes;
FeatureListItem.defaultProps = defaultProps;

export default FeatureListItem;
